import DynamicTabs from "../../../components/Tabs/Tabs";
import { Box } from "@mui/material";
import ViewEnrolledStudents from "../manage-enrolled-students/view";
import { ViewSecOutline } from "../manage-sec-course-outline/view";
import ViewAssignments from "../manage-assignments/view";
import ViewAttendance from "../manage-attendance/view";
import ViewGrade from "../manage-grade/view";
import {
  HasPermission,
  HasPermissionTab,
} from "../../../helper/helperFunction";
import { useSearchParams } from "react-router-dom";
import { useEffect, useState } from "react";

function CourseTabs(params) {
  const [searchParams, setSearchParams] = useSearchParams();
  const [activeTabKey, setActiveTabKey] = useState("course_outline");

  useEffect(() => {
    const tabFromUrl = searchParams.get("tab");
    if (tabFromUrl) {
      setActiveTabKey(tabFromUrl);
    }
  }, [searchParams]);

  const handleTabChange = (key) => {
    setActiveTabKey(key);
    setSearchParams({ tab: key }); // update URL
  };

  const tabs = [
    {
      label: "Course Outline",
      key: "course_outline",
      content: (
        <HasPermission permission="manage-section-outline.view">
          <ViewSecOutline courseId={params.courseId ?? ""} />
        </HasPermission>
      ),
    },
    {
      label: "Enrolled Students",
      key: "enrolled_students",
      content: (
        <HasPermission permission="manage-enrolled-students.view">
          <ViewEnrolledStudents
            courseId={params.courseId}
            setReloadEnroll={params.setReloadEnroll}
            locationId={params.locationId}
            cohort_id={params.cohort_id}
          />
        </HasPermission>
      ),
    },
    {
      label: "Attendance",
      key: "attendance",
      content: (
        <HasPermission permission="manage-attendance.view">
          <ViewAttendance setReRender={params.setReRender} />
        </HasPermission>
      ),
    },
    {
      label: "Assignment",
      key: "assignment",
      content: (
        <HasPermission permission="manage-assignment.view">
          <ViewAssignments
            sectionName={params.sectionName}
            courseTitle={params.courseTitle}
            sectionId={params.sectionId}
            courseId={params.courseId}
          />
        </HasPermission>
      ),
    },
    {
      label: "Reviews",
      key: "reviews",
      content: (
        <HasPermission permission="manage-reviews.view">
          <></>
        </HasPermission>
      ),
    },
    {
      label: "Grade Book",
      key: "grade_book",
      content: (
        <HasPermission permission="manage-gradebook.view">
          <ViewGrade />
        </HasPermission>
      ),
    },
  ];

  const allowedTabs = tabs.filter((tab) => {
    const hasPermission = HasPermissionTab(tab.content.props.permission);
    return (
      tab.content !== null &&
      (tab.content.props.permission ? hasPermission : true)
    );
  });

  return (
    <Box className="settings" mt={"40px"}>
      {allowedTabs && allowedTabs.length > 0 && (
        <DynamicTabs
          tabs={allowedTabs}
          activeTabKey={activeTabKey}
          onTabChange={handleTabChange}
          setTabsCount={params.setTabsCount}
        />
      )}
    </Box>
  );
}

export default CourseTabs;
